import { render, staticRenderFns } from "./ChangeTransactionCategoryPopup.vue?vue&type=template&id=6cb069c5&"
import script from "./ChangeTransactionCategoryPopup.vue?vue&type=script&lang=js&"
export * from "./ChangeTransactionCategoryPopup.vue?vue&type=script&lang=js&"
import style0 from "./ChangeTransactionCategoryPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports